module.exports = __webpack_public_path__ + "img/icon1.e4a77cee.png";